<template>
  <div class="req-status">
    <p v-if="!data || data.length < 1" class="no_data">{{ $lange == "en" ? "No Data" : "暂无数据" }}</p>
    <e-charts
      v-else
      style="width: 100%"
      :options="options"
      auto-resize
    ></e-charts>
  </div>
</template>

<script>
// 请求数据-按状态

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";
import theme from "./theme";

export default {
  name: "RequestProblemBar",
  components: { ECharts },
  props: {
    title: String,
    data: {
      type: Array,
    },
  },
  computed: {
    options() {
      const seriesData = this.data.map((item) => ({
        name: item.name,
        value: item.count,
      }));
      const legendData = this.data.map((item) => item.name);
      return {
        ...theme,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}: {c}"
        },
        xAxis: {
          type: "category",
          data: legendData,
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        grid: {
          left: 16,
          right: 16,
          containLabel: true,
          show: true,
        },
        series: [
          {
            name: this.title,
            type: "bar",
            data: seriesData,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value : ""),
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.req-status {
  flex: 1;
}
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
</style>
